import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { GasInputBoolean, NgOnChange } from '@cikrf/gas-utils/decorators';
import { Observable } from 'rxjs';

const MAX_VISISBLE_ACTIONS_COUNT = 100;

/**
 * @description Вспомогательный компонент-кнопка "Выполнить действие"
 *
 * @example <gas-action-button invert disabled multiple="1"></gas-action-button>
 */
@Component({
  selector: 'gas-action-button',
  templateUrl: './gas-action-button.component.html',
  styleUrls: ['./gas-action-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasActionButtonComponent {
  @Input()
  public title = 'Выполнить действие';

  @Input()
  public iconName = 'layout-lightning';

  @Input()
  public iconColor = '#ffffff';

  @Input()
  public iconSize = 18;

  @HostBinding('class._disabled')
  @GasInputBoolean()
  @Input()
  public disabled: string | boolean = false;

  @HostBinding('class._inverted')
  @GasInputBoolean()
  @Input()
  public invert: string | boolean = false;

  @NgOnChange()
  @Input('multiple')
  public multiple$: Observable<string | number>;

  public getFormattedActionCount(actionCount: string | number): string {
    return isNaN(+actionCount) ? '' : (
      +actionCount > MAX_VISISBLE_ACTIONS_COUNT
        ? '100+'
        : actionCount.toString()
    );
  }
}
